import { render, staticRenderFns } from "./StockAdjustment.vue?vue&type=template&id=1e9680d6&scoped=true"
import script from "./StockAdjustment.vue?vue&type=script&lang=js"
export * from "./StockAdjustment.vue?vue&type=script&lang=js"
import style0 from "./StockAdjustment.vue?vue&type=style&index=0&id=1e9680d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9680d6",
  null
  
)

export default component.exports